export default "__VITE_ASSET__33cfab70__"